import { HomeScreenThemeSizeConfig } from './types';

const medium: HomeScreenThemeSizeConfig = {
  homeScreen: {},
};

export default medium;
